import {
  Authenticated,
  CanAccess,
  ErrorComponent,
  Refine,
} from "@refinedev/core";
import { RefineKbar, RefineKbarProvider } from "@refinedev/kbar";

import routerBindings, {
  CatchAllNavigate,
  DocumentTitleHandler,
  // DocumentTitleHandler,
  NavigateToResource,
  UnsavedChangesNotifier,
} from "@refinedev/react-router-v6";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import { authProvider, dataProvider, externalUploadProvider } from "providerrs";
import toast, { ToastBar, Toaster } from "react-hot-toast";
import { resources } from "config/resources";
import { DashBoardLayout, AuthLayout } from "components/layout";
import { Tooltip } from "react-tooltip";
import {
  ChangePassword,
  CreateOrgAccount,
  CreateOrgRole,
  CreateOrganization,
  Dashboard,
  EditOrgAccount,
  EditOrgRole,
  EditOrganization,
  ForgotPassword,
  Login,
  OrgAccountDetail,
  OrgAccountList,
  OrgRoleDetail,
  OrgRoleList,
  OrganizationDetail,
  OrganizationList,
  ResetPassword,
} from "routes";
import {
  AboutActiupList,
  ConditionDetail,
  EditCondition,
  ExchangeRateList,
} from "routes/other";
import {
  BannerDetail,
  BlogDetail,
  BlogList,
  BlogSubCategoryDetail,
  BlogSubCategoryList,
  CreateBlog,
  CreateBlogSubCategory,
  CreateHomepageCoupon,
  EditBanner,
  EditBlog,
  EditBlogSubCategory,
  EditHomePage,
  EditHomepageCoupon,
  HomepageCouponDetail,
  HomepageCouponList,
  HomepageDetail,
} from "routes/mkt";
import {
  AttractionEventList,
  AttractionQRCodeDetail,
  AttractionQRCodeList,
  CreateAttractionEvent,
  CreateAttractionQRCode,
  CreateSrpotEvent,
  EditAttractionEvent,
  EditSrpotEvent,
  MassImportPasscodes,
  PasscodeList,
  SportEventDetail,
  SportEventList,
  EventAddonList,
  EventAddonDetail,
  CreateEventAddon,
  EditEventAddon,
} from "routes/event";
import {
  CreateFipixAccount,
  CreateFipixEvent,
  EditFipixAccount,
  EditFipixEvent,
  FipixAccountDetail,
  FipixEventDetail,
  FipixEventList,
  ListFipixAccount,
} from "routes/fipix";
import {
  ContactList,
  CreateSupportCategory,
  CreateSupportQA,
  EditSupportCategory,
  EditSupportQA,
  SupportCategoryList,
  SupportCategoyDetail,
  SupportQADetail,
  SupportQAList,
} from "routes/cs";
import { EditOrder, OrderDetail, OrderList } from "routes/orders";
import { ScrollTopTop } from "components/scrollToTop";
import {
  CreatePickupAccount,
  EditPickupAccount,
  EditPickupAttractionParticipant,
  EditPickupEvent,
  EditPickupSportParticipant,
  PickupAccountDetail,
  PickupAccountList,
  PickupAttractionParticipantDetail,
  PickupAttractionParticipantList,
  PickupEventDetail,
  PickupEventList,
  PickupSportParticipantDetail,
  PickupSportParticipantList,
} from "routes/pickup";
import {
  AttractionParticipantDetail,
  AttractionParticipantList,
  EditAttractionParticipant,
  EditSportParticipant,
  MassImportAttractionParticipant,
  MassImportSportParticipant,
  SportParticipantDetail,
  SportParticipantList,
} from "routes/participants";
import ProfilePage from "routes/profile";
import "./utills/i18n";
import Coupons from "routes/wps/coupons";
import EditProfile from "routes/profile/edit";
import ChangePasswordWPS from "routes/profile/changePassword";
import WPSOrders from "routes/wps/orders";
import WPSOrderDetail from "routes/wps/orders/detail";
import WPSEditOrder from "routes/wps/orders/edit";
import { useMemo } from "react";
import { useTranslation as useI18nextTranslation } from "react-i18next";
import WPSHome from "routes/wps/home";
import {
  AdminAccountDetail,
  AdminAccountList,
  AdminAccountRoleDetail,
  AdminAccountRoleList,
  CreateAdminAccount,
  CreateAdminAccountRole,
  EditAdminAccount,
  EditAdminAccountRole,
} from "routes/adminAccount";
import WPSRolesDetail from "routes/wps/organizations/roles/detail";
import WPSRolesList from "routes/wps/organizations/roles/list";
import WPSRolesEdit from "routes/wps/organizations/roles/edit";
import WPSRolesCreate from "routes/wps/organizations/roles/create";
import WPSAccountList from "routes/wps/organizations/accounts/list";
import WPSAccountDetail from "routes/wps/organizations/accounts/detail";
import WPSAccountEdit from "routes/wps/organizations/accounts/edit";
import WPSAccountCreate from "routes/wps/organizations/accounts/create";
import WPSOrganizationInformation from "routes/wps/organizations/information/detail";
import WPSOrganizationInformationEdit from "routes/wps/organizations/information/edit";
import WPSAttendeesSportsList from "routes/wps/attendees/sports/list";
import WPSAttendeesAttractionsList from "routes/wps/attendees/attractions/list";
import WPSAttendeesSportsEdit from "routes/wps/attendees/sports/edit";
import WPSAttendeesSportsDetail from "routes/wps/attendees/sports/detail";
import WPSAttendeesAttractionsDetail from "routes/wps/attendees/attractions/detail";
import EwaiverListPage from "routes/ewaiver/list";
import EwaiverCreatePage from "routes/ewaiver/create";
import EwaiverDetailPage from "routes/ewaiver/detail";
import EwaiverEditPage from "routes/ewaiver/edit";
import { workspaceDataProvider } from "providerrs/workspaceData";
import { WPSportEventList } from "routes/wps/events/sports/list";
import NotFound from "components/notFound";
import { EditWPSSportEvent } from "routes/wps/events/sports/edit";
import { CreateWPSSportEvent } from "routes/wps/events/sports/create";
import { WPSSportEventDetail } from "routes/wps/events/sports/detail";
import {
  CreatePromotion,
  EditPromotionCondition,
  EditPromotionCoupon,
  PromotionConditionDetail,
  PromotionConditionList,
  PromotionCouponDetail,
  PromotionCouponList,
} from "routes/promotion";
import { accessControlProvider } from "providerrs/accessControl";
import { WPSPromotionConditionList } from "routes/wps/promotion/condition/list";
import { WPSPromotionCouponList } from "routes/wps/promotion/coupon/list";
import { WPSPromotionConditionDetail } from "routes/wps/promotion/condition/detail";
import { WPSPromotionCouponDetail } from "routes/wps/promotion/coupon/detail";
import { WPSCreatePromotion } from "routes/wps/promotion/coupon/create";
import { EditWPSPromotionCoupon } from "routes/wps/promotion/coupon/edit";
import { EditWPSPromotionCondition } from "routes/wps/promotion/condition/edit";
import ClubListPage from "routes/club/pages/list";
import CustomerAccountListPage from "routes/customerAccount/pages/list";
import CustomerAccountDetailPage from "routes/customerAccount/pages/detail";
import Fipix from "routes/wps/fipix";
import WPSEInvoicesPage from "routes/wps/organizations/einvoices";
import WPSEditEInvoicesSettings from "routes/wps/organizations/einvoices/edit";
import { canAccessByType, capitalizeFirstLetter } from "utills/helpers";
import { UserType } from "interfaces";
import { isEmpty } from "lodash";
import GroupManagementListPage from "routes/group/pages/list";
import GroupManagementDetailPage from "routes/group/pages/detail";
import GroupManagementEditPage from "routes/group/pages/edit";
import { getAuthUserType } from "utills/authType";
import Checkin from "routes/wps/checkin/introduction";
import WPSCheckinEventsListPage from "routes/wps/checkin/events/pages/list";
import WPSCheckinEventsEditPage from "routes/wps/checkin/events/pages/edit";
import WPSCheckinEventsDetailPage from "routes/wps/checkin/events/pages/detail";
import WPSCheckinSportParticipantsListPage from "routes/wps/checkin/sports/pages/list";
import WPSCheckinSportParticipantsEditPage from "routes/wps/checkin/sports/pages/edit";
import WPSCheckinSportParticipantsDetailPage from "routes/wps/checkin/sports/pages/detail";
import WPSCheckinAttractionParticipantsListPage from "routes/wps/checkin/attractions/pages/list";
import WPSCheckinAttractionParticipantsEditPage from "routes/wps/checkin/attractions/pages/edit";
import WPSCheckinAttractionParticipantsDetailPage from "routes/wps/checkin/attractions/pages/detail";

const getCurrentUserType = () => {
  try {
    const user = JSON.parse(localStorage.getItem("USER") ?? "{}");

    if (user?.type === UserType.ADMIN || user?.type === UserType.WPS) {
      return user.type;
    }
  } catch (error) {
    return getAuthUserType();
  }

  return getAuthUserType();
};

function RedirectToWSRoute() {
  const location = useLocation();
  const newPath = location.pathname.replace(/^\/wps/, "") || "/";
  return <Navigate to={newPath} replace />;
}

function App() {
  const type = getCurrentUserType();
  const { i18n: i18nInstance } = useI18nextTranslation();
  const locale = i18nInstance.language;

  const i18nProvider = useMemo(
    () => ({
      translate: (key: string, params?: any) => i18nInstance.t(key, params),
      changeLocale: (lang: string) => i18nInstance.changeLanguage(lang),
      getLocale: () => locale,
    }),
    [i18nInstance, locale]
  );

  return (
    <BrowserRouter>
      <RefineKbarProvider>
        {type !== "" && (type === "admin" || type === "wps") && (
          <Refine
            i18nProvider={i18nProvider}
            dataProvider={{
              default: type === "admin" ? dataProvider : workspaceDataProvider,
              externalUpload: externalUploadProvider,
            }}
            routerProvider={routerBindings}
            accessControlProvider={accessControlProvider}
            authProvider={authProvider}
            resources={resources}
            options={{
              syncWithLocation: true,
              warnWhenUnsavedChanges: true,
              useNewQueryKeys: true,
              projectId: "0LJPGP-fYniAH-wGbbcW",
              reactQuery: {
                clientConfig: {
                  defaultOptions: {
                    queries: {
                      retry: false,
                    },
                  },
                },
              },
            }}
          >
            <ScrollTopTop />
            <Routes>
              <Route
                element={
                  <Authenticated
                    key="authenticated-inner"
                    fallback={<CatchAllNavigate to="/login" />}
                  >
                    <DashBoardLayout>
                      <CanAccess fallback={<NotFound />}>
                        <Outlet />
                      </CanAccess>
                    </DashBoardLayout>
                  </Authenticated>
                }
              >
                {type === "wps" ? (
                  <>
                    <Route path="/wps/*" element={<RedirectToWSRoute />} />
                    <Route
                      index
                      element={<Navigate to="/dashboard/overview" replace />}
                    />
                    <Route path="/coupon" element={<Coupons />} />
                    <Route path="/organization">
                      <Route path="role" element={<WPSRolesList />} />
                      <Route path="role/:id" element={<WPSRolesDetail />} />
                      <Route path="role/:id/edit" element={<WPSRolesEdit />} />
                      <Route path="role/create" element={<WPSRolesCreate />} />
                      <Route path="account" element={<WPSAccountList />} />
                      <Route
                        path="account/:id"
                        element={<WPSAccountDetail />}
                      />
                      <Route
                        path="account/:id/edit"
                        element={<WPSAccountEdit />}
                      />
                      <Route
                        path="account/create"
                        element={<WPSAccountCreate />}
                      />
                      <Route
                        path="info"
                        element={<WPSOrganizationInformation />}
                      />
                      <Route
                        path="info/edit"
                        element={<WPSOrganizationInformationEdit />}
                      />
                      <Route path="einvoice" element={<WPSEInvoicesPage />} />
                      <Route path="einvoice/edit" element={<WPSEditEInvoicesSettings />} />
                    </Route>
                    <Route
                      path="/dashboard"
                      element={<Navigate to="/dashboard/overview" replace />}
                    />
                    <Route
                      path="/dashboard/overview"
                      element={<Dashboard />}
                    />
                    <Route
                      path="/dashboard/event"
                      element={<Dashboard />}
                    />
                    <Route path="/orders">
                      <Route index element={<WPSOrders />} />
                      <Route path=":id" element={<WPSOrderDetail />} />
                      <Route path=":id/edit" element={<WPSEditOrder />} />
                    </Route>
                    <Route path="/attendees">
                      <Route
                        path="sports"
                        element={<WPSAttendeesSportsList />}
                      />
                      <Route
                        path="sports/:id/edit"
                        element={<WPSAttendeesSportsEdit />}
                      />
                      <Route
                        path="sports/:id/detail"
                        element={<WPSAttendeesSportsDetail />}
                      />
                      <Route
                        path="attractions"
                        element={<WPSAttendeesAttractionsList />}
                      />
                      <Route
                        path="attractions/:id/detail"
                        element={<WPSAttendeesAttractionsDetail />}
                      />
                    </Route>
                    <Route path="/events">
                      <Route path="sports" element={<WPSportEventList />} />
                      <Route
                        path="sports/:id"
                        element={<WPSSportEventDetail />}
                      />
                      <Route
                        path="sports/:id/edit"
                        element={<EditWPSSportEvent />}
                      />
                      <Route
                        path="sports/create"
                        element={<CreateWPSSportEvent />}
                      />
                    </Route>
                    <Route path="/promotion">
                      <Route
                        path="condition"
                        element={<WPSPromotionConditionList />}
                      />
                      <Route
                        path="condition/:id"
                        element={<WPSPromotionConditionDetail />}
                      />
                      <Route
                        path="condition/:id/edit"
                        element={<EditWPSPromotionCondition />}
                      />
                      <Route
                        path="coupon"
                        element={<WPSPromotionCouponList />}
                      />
                      <Route
                        path="coupon/create/:type"
                        element={<WPSCreatePromotion />}
                      />
                      <Route
                        path="coupon/:id"
                        element={<WPSPromotionCouponDetail />}
                      />
                      <Route
                        path="coupon/:id/edit"
                        element={<EditWPSPromotionCoupon />}
                      />
                    </Route>
                    <Route path="/fipix" element={<Fipix />} />
                    <Route path="/check-in">
                      <Route
                        path="introduction"
                        element={<Checkin />}
                      />

                      <Route
                        path="events"
                        element={<WPSCheckinEventsListPage />}
                      />
                      <Route
                        path="events/:id/edit"
                        element={<WPSCheckinEventsEditPage />}
                      />
                      <Route
                        path="events/:id/detail"
                        element={<WPSCheckinEventsDetailPage />}
                      />

                      <Route
                        path="sport-participants"
                        element={<WPSCheckinSportParticipantsListPage />}
                      />
                      <Route
                        path="sport-participants/:id/edit"
                        element={<WPSCheckinSportParticipantsEditPage />}
                      />
                      <Route
                        path="sport-participants/:id/detail"
                        element={<WPSCheckinSportParticipantsDetailPage />}
                      />

                      <Route
                        path="attraction-participants"
                        element={<WPSCheckinAttractionParticipantsListPage />}
                      />
                      <Route
                        path="attraction-participants/:id/edit"
                        element={<WPSCheckinAttractionParticipantsEditPage />}
                      />
                      <Route
                        path="attraction-participants/:id/detail"
                        element={<WPSCheckinAttractionParticipantsDetailPage />}
                      />
                    </Route>
                  </>
                ) : (
                  <></>
                )}

                {type === "admin" ? (
                  <>
                    <Route
                      path="/"
                      index
                      element={<Navigate to="/dashboard/overview" replace />}
                    />
                    <Route path="/dashboard">
                      <Route path=":id" element={<Dashboard />} />
                    </Route>
                    <Route
                      index
                      element={
                        <NavigateToResource resource="/organizaion/org" />
                      }
                    />
                    <Route path="/organization">
                      <Route path="roles" element={<OrgRoleList />} />
                      <Route path="roles/:id" element={<OrgRoleDetail />} />
                      <Route path="roles/create" element={<CreateOrgRole />} />
                      <Route path="roles/:id/edit" element={<EditOrgRole />} />

                      <Route path="org" element={<OrganizationList />} />
                      <Route path="org/:id" element={<OrganizationDetail />} />
                      <Route
                        path="org/create"
                        element={<CreateOrganization />}
                      />
                      <Route
                        path="org/:id/edit"
                        element={<EditOrganization />}
                      />

                      <Route path="accounts" element={<OrgAccountList />} />
                      <Route
                        path="accounts/:id"
                        element={<OrgAccountDetail />}
                      />
                      <Route
                        path="accounts/create"
                        element={<CreateOrgAccount />}
                      />
                      <Route
                        path="accounts/:id/edit"
                        element={<EditOrgAccount />}
                      />
                    </Route>
                    <Route path="/fipix">
                      <Route path="accounts" element={<ListFipixAccount />} />
                      <Route
                        path="accounts/:id"
                        element={<FipixAccountDetail />}
                      />
                      <Route
                        path="accounts/create"
                        element={<CreateFipixAccount />}
                      />
                      <Route
                        path="accounts/:id/edit"
                        element={<EditFipixAccount />}
                      />
                      <Route path="events" element={<FipixEventList />} />
                      <Route path="events/:id" element={<FipixEventDetail />} />
                      <Route
                        path="events/create"
                        element={<CreateFipixEvent />}
                      />
                      <Route
                        path="events/:id/edit"
                        element={<EditFipixEvent />}
                      />
                    </Route>
                    <Route path="/other">
                      <Route
                        path="club"
                        element={<ClubListPage />}
                      />

                      <Route
                        path="about-actiup"
                        element={<AboutActiupList />}
                      />
                      <Route
                        path="about-actiup/:id"
                        element={<ConditionDetail />}
                      />
                      <Route
                        path="about-actiup/:id/edit"
                        element={<EditCondition />}
                      />

                      <Route
                        path="exchange-rate"
                        element={<ExchangeRateList />}
                      />
                    </Route>
                    <Route path="/mkt">
                      <Route
                        path="homepage"
                        index
                        element={<Navigate to="/mkt/homepage/detail" replace />}
                      />
                      <Route
                        path="homepage/detail"
                        element={<HomepageDetail />}
                      />
                      <Route path="homepage/edit" element={<EditHomePage />} />

                      <Route
                        path="banner"
                        index
                        element={<Navigate to="/mkt/banner/detail" replace />}
                      />
                      <Route path="banner/detail" element={<BannerDetail />} />
                      <Route path="banner/edit" element={<EditBanner />} />

                      <Route
                        path="sub-category"
                        element={<BlogSubCategoryList />}
                      />
                      <Route
                        path="sub-category/:id"
                        element={<BlogSubCategoryDetail />}
                      />
                      <Route
                        path="sub-category/:id/edit"
                        element={<EditBlogSubCategory />}
                      />
                      <Route
                        path="sub-category/create"
                        element={<CreateBlogSubCategory />}
                      />

                      <Route path="blog" element={<BlogList />} />
                      <Route path="blog/:id" element={<BlogDetail />} />
                      <Route path="blog/:id/edit" element={<EditBlog />} />
                      <Route path="blog/create" element={<CreateBlog />} />

                      <Route
                        path="homepage-coupon"
                        element={<HomepageCouponList />}
                      />
                      <Route
                        path="homepage-coupon/create"
                        element={<CreateHomepageCoupon />}
                      />
                      <Route
                        path="homepage-coupon/:id"
                        element={<HomepageCouponDetail />}
                      />
                      <Route
                        path="homepage-coupon/:id/edit"
                        element={<EditHomepageCoupon />}
                      />
                    </Route>
                    <Route path="/events">
                      <Route path="sports" element={<SportEventList />} />
                      <Route
                        path="sports/create"
                        element={<CreateSrpotEvent />}
                      />
                      <Route path="sports/:id" element={<SportEventDetail />} />
                      <Route
                        path="sports/:id/edit"
                        element={<EditSrpotEvent />}
                      />

                      <Route
                        path="attractions"
                        element={<AttractionEventList />}
                      />
                      <Route
                        path="attractions/create"
                        element={<CreateAttractionEvent />}
                      />
                      <Route
                        path="attractions/:id/edit"
                        element={<EditAttractionEvent />}
                      />

                      <Route
                        path="attraction-qr-code"
                        element={<AttractionQRCodeList />}
                      />
                      <Route
                        path="attraction-qr-code/:id"
                        element={<AttractionQRCodeDetail />}
                      />
                      <Route
                        path="attraction-qr-code/create"
                        element={<CreateAttractionQRCode />}
                      />

                      <Route path="passcodes" element={<PasscodeList />} />
                      <Route
                        path="passcodes/create"
                        element={<MassImportPasscodes />}
                      />

                      <Route path="addons" element={<EventAddonList />} />
                      <Route
                        path="addons/create"
                        element={<CreateEventAddon />}
                      />
                      <Route path="addons/:id" element={<EventAddonDetail />} />
                      <Route
                        path="addons/:id/edit"
                        element={<EditEventAddon />}
                      />
                    </Route>
                    <Route path="/cs">
                      <Route
                        path="support-category"
                        element={<SupportCategoryList />}
                      />
                      <Route
                        path="support-category/:id"
                        element={<SupportCategoyDetail />}
                      />
                      <Route
                        path="support-category/:id/edit"
                        element={<EditSupportCategory />}
                      />
                      <Route
                        path="support-category/create"
                        element={<CreateSupportCategory />}
                      />

                      <Route path="support-qa" element={<SupportQAList />} />
                      <Route
                        path="support-qa/:id"
                        element={<SupportQADetail />}
                      />
                      <Route
                        path="support-qa/:id/edit"
                        element={<EditSupportQA />}
                      />
                      <Route
                        path="support-qa/create"
                        element={<CreateSupportQA />}
                      />

                      <Route path="contacts" element={<ContactList />} />
                    </Route>
                    <Route path="/orders">
                      <Route index element={<OrderList />} />
                      <Route path=":id" element={<OrderDetail />} />
                      <Route path=":id/edit" element={<EditOrder />} />
                    </Route>
                    <Route path="/group-management">
                      <Route index element={<GroupManagementListPage />} />
                      <Route
                        path="detail/:id"
                        element={<GroupManagementDetailPage />}
                      />
                      <Route path="edit/:id" element={<GroupManagementEditPage />} />
                    </Route>
                    <Route path="/pickup">
                      <Route path="accounts" element={<PickupAccountList />} />
                      <Route
                        path="accounts/:id"
                        element={<PickupAccountDetail />}
                      />
                      <Route
                        path="accounts/create"
                        element={<CreatePickupAccount />}
                      />
                      <Route
                        path="accounts/:id/edit"
                        element={<EditPickupAccount />}
                      />

                      <Route path="events" element={<PickupEventList />} />
                      <Route
                        path="events/:id"
                        element={<PickupEventDetail />}
                      />
                      <Route
                        path="events/:id/edit"
                        element={<EditPickupEvent />}
                      />

                      <Route
                        path="sport-participants"
                        element={<PickupSportParticipantList />}
                      />
                      <Route
                        path="sport-participants/:id"
                        element={<PickupSportParticipantDetail />}
                      />
                      <Route
                        path="sport-participants/:id/edit"
                        element={<EditPickupSportParticipant />}
                      />

                      <Route
                        path="attraction-participants"
                        element={<PickupAttractionParticipantList />}
                      />
                      <Route
                        path="attraction-participants/:id"
                        element={<PickupAttractionParticipantDetail />}
                      />
                      <Route
                        path="attraction-participants/:id/edit"
                        element={<EditPickupAttractionParticipant />}
                      />
                    </Route>
                    <Route path="/ewaiver">
                      <Route index element={<EwaiverListPage />} />
                      <Route path="create" element={<EwaiverCreatePage />} />
                      <Route
                        path="detail/:id"
                        element={<EwaiverDetailPage />}
                      />
                      <Route path="edit/:id" element={<EwaiverEditPage />} />
                    </Route>
                    <Route path="/participants">
                      <Route
                        path="attraction"
                        element={<AttractionParticipantList />}
                      />
                      <Route
                        path="attraction/:id"
                        element={<AttractionParticipantDetail />}
                      />
                      <Route
                        path="attraction/:id/edit"
                        element={<EditAttractionParticipant />}
                      />
                      <Route
                        path="attraction/mass-import"
                        element={<MassImportAttractionParticipant />}
                      />

                      <Route path="sport" element={<SportParticipantList />} />
                      <Route
                        path="sport/:id"
                        element={<SportParticipantDetail />}
                      />
                      <Route
                        path="sport/:id/edit"
                        element={<EditSportParticipant />}
                      />
                      <Route
                        path="sport/mass-import"
                        element={<MassImportSportParticipant />}
                      />
                    </Route>
                    <Route path="/admin-accounts">
                      <Route path="roles" element={<AdminAccountRoleList />} />
                      <Route
                        path="roles/:id"
                        element={<AdminAccountRoleDetail />}
                      />
                      <Route
                        path="roles/create"
                        element={<CreateAdminAccountRole />}
                      />
                      <Route
                        path="roles/:id/edit"
                        element={<EditAdminAccountRole />}
                      />

                      <Route path="accounts" element={<AdminAccountList />} />
                      <Route
                        path="accounts/:id"
                        element={<AdminAccountDetail />}
                      />
                      <Route
                        path="accounts/create"
                        element={<CreateAdminAccount />}
                      />
                      <Route
                        path="accounts/:id/edit"
                        element={<EditAdminAccount />}
                      />
                    </Route>
                    <Route path="/customer-accounts">
                      <Route index element={<CustomerAccountListPage />} />
                      <Route
                        path="detail/:id"
                        element={<CustomerAccountDetailPage />}
                      />
                    </Route>
                    <Route path="/promotion">
                      <Route path="coupon" element={<PromotionCouponList />} />
                      <Route
                        path="coupon/create/:type"
                        element={<CreatePromotion />}
                      />
                      <Route
                        path="coupon/:id"
                        element={<PromotionCouponDetail />}
                      />
                      <Route
                        path="coupon/:id/edit"
                        element={<EditPromotionCoupon />}
                      />
                      <Route
                        path="condition"
                        element={<PromotionConditionList />}
                      />
                      <Route
                        path="condition/:id"
                        element={<PromotionConditionDetail />}
                      />
                      <Route
                        path="condition/:id/edit"
                        element={<EditPromotionCondition />}
                      />
                    </Route>
                  </>
                ) : (
                  <></>
                )}
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/profile/edit" element={<EditProfile />} />
                <Route
                  path="/profile/change-password"
                  element={<ChangePasswordWPS />}
                />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route
                element={
                  <Authenticated
                    key="authenticated-outer"
                    fallback={
                      <AuthLayout>
                        <Outlet />
                      </AuthLayout>
                    }
                  >
                    <NavigateToResource />
                  </Authenticated>
                }
              >
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
              </Route>
            </Routes>

            <RefineKbar />
            <UnsavedChangesNotifier />
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 6000,
                className: "!text-sm",
                success: {
                  className: "!bg-green-50 !text-green-800",
                  style: { wordBreak: "break-word" },
                },
                error: {
                  className: "!bg-red-50 !text-red-800",
                  style: { wordBreak: "break-word" },
                },
              }}
            >
              {(t) => {
                return (
                  <div
                    className="w-auto cursor-pointer"
                    style={{wordBreak: "break-word"}}
                    onClick={() => toast.dismiss(t.id)}
                  >
                    <ToastBar toast={t} />
                  </div>
                );
              }}
            </Toaster>
            <Tooltip
              id="tooltip"
              place="bottom"
              className="text-sm font-normal max-w-60 whitespace-pre-wrap z-[61]"
              style={{ wordBreak: "break-word" }}
              clickable={true}
              render={({ content, activeAnchor }) => <span>{content}</span>}
            />
              <DocumentTitleHandler
                handler={(title) => {
                  if (type === UserType.WPS) return "ActiUp Workspace";
                  if (title?.pathname === "/dashboard/event") {
                    return "Dashboard > Event";
                  }

                  const parent = title.resource?.meta?.parent;
                  const name = title.resource?.name ?? "Actiup Admin";
                  const action = title.action !== "list"
                    ? capitalizeFirstLetter(title.action === "show" ? "detail" : (title.action ?? ""))
                    : null;
                  
                  return [parent, name, action].filter(Boolean).join(" > ");
                }}
              />
          </Refine>
        )}
      </RefineKbarProvider>
    </BrowserRouter>
  );
}

export default App;
